import { render, staticRenderFns } from "./Locations.vue?vue&type=template&id=50cfefc6&scoped=true&"
import script from "./Locations.vue?vue&type=script&lang=js&"
export * from "./Locations.vue?vue&type=script&lang=js&"
import style0 from "./Locations.vue?vue&type=style&index=0&id=50cfefc6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cfefc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50cfefc6')) {
      api.createRecord('50cfefc6', component.options)
    } else {
      api.reload('50cfefc6', component.options)
    }
    module.hot.accept("./Locations.vue?vue&type=template&id=50cfefc6&scoped=true&", function () {
      api.rerender('50cfefc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/reporting/Locations.vue"
export default component.exports